import React, { useEffect, useState } from 'react';
import { Stats } from "@react-three/drei";
import './App.css';
import { Router } from "./containers/Router/Router";
import { ContextContainer } from "./containers/ContextContainer/ContextContainer";
import GUI from "lil-gui";
import { FullscreenButton } from "./components/FullscreenButton/FullscreenButton";
import { TouchFeedback } from "./components/TouchFeedback/TouchFeedback";

export const gui = new GUI();
gui.hide()

function App() {
    const [showStats, setShowStats] = useState(false);
    const [mousePointer, setMousePointer] = useState(true);

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            const key = event.key;
            if (key === 'Tab') {
                event.preventDefault();
            }
            if (key === 'u') {
                gui.show(gui._hidden);
            }
            if (key === 's') {
                setShowStats((prevState) => !prevState)
            }
            if (key === 'g') {
                window.location.hash = '/game';
            }
            if (key === 'm') {
                setMousePointer((prevState) => !prevState);
            }
        }
        window.addEventListener('keydown', handleKeydown);

        const handleResize = () => {
            window.location.reload();
        }
        window.addEventListener('resize', handleResize);

        const preventContextMenu = (event: any) => {
            event.preventDefault()
        }
        document.addEventListener('contextmenu', preventContextMenu);
        return () => {
            window.removeEventListener('keydown', handleKeydown);
            window.removeEventListener('resize', handleResize);
            document.removeEventListener('contextmenu', preventContextMenu);
        }
    }, []);

    // Enable mouse pointer
    useEffect(() => {
        document.head.querySelector('style#mouse-style')?.remove();
        if (!mousePointer) {

            document.head.insertAdjacentHTML("beforeend", `<style id="mouse-style"> *, *:before, *:after { cursor: none !important; }</style>`)
        }
    }, [mousePointer])

  return (
    <ContextContainer>
        {showStats ? <Stats showPanel={0} /> : null}
        <TouchFeedback />
        <FullscreenButton />
        <Router />
        {/*{renderGame ? <GamePlayer /> : <FrontPage />}*/}

    </ContextContainer>
  );
}

export default App;
